import { z } from "zod";
import { zAddressDataSchema } from "../zAddressInfo";
import { zRoutePointCommonSchema } from "./routePoint.common";
/**
 * RoutePoint DTO schema - represents data as it comes from the server (flat structure)
 * Contains all scalar address-related fields as separate properties
 */
export const zRoutePointSchemaDto = zRoutePointCommonSchema.extend({
    idCreatedBy: z.string().nullish(),
}).extend(zAddressDataSchema.shape);
export const zRoutePointSchemaCreateDto = zRoutePointSchemaDto.omit({ id: true });
